import makeStyles from "@mui/styles/makeStyles";
import { colors } from "@zapalacorp/tokens";

type StyleProps = {
  type?: "error" | "alert" | "success" | "warning" | "info";
  width?: string;
  maxWidth?: string;
};

const styles = makeStyles(() => ({
  mainDialog: {
    width: (props: StyleProps) => {
      return props?.width || "50%";
    },
    maxWidth: (props: StyleProps) => {
      return props?.maxWidth || "auto";
    },
    "@media (max-width: 1200px)": {
      width: "50%",
    },
    "@media (max-width: 900px)": {
      width: "60%",
    },
    "@media (max-width: 600px)": {
      width: "90% !important",
    },
  },
  title: {
    gap: "1rem",
    display: "flex",
    alignItems: "center",
  },
  iconDiv: {
    backgroundColor: (props: StyleProps) => {
      if (props?.type) {
        if (props?.type === "error") return "#FECDCA";
        if (props?.type === "alert") return colors.error50;
        if (props?.type === "warning") return "#FEDF89";
        if (props?.type === "info") return "#D1E9FF";
      }

      return "#D1FADF";
    },
    display: "flex",
    alignItems: "center",
    padding: "8px",
    borderRadius: "9999px",
  },
}));

export default styles;
